import AppConstants from '../constants/AppConstants';
import translations from '../locales.js';
import store from './redux';

const publisherRole = AppConstants.ROLE_PUBLISHER;
const adminRole = AppConstants.ROLE_ADMIN;
const qaRole = AppConstants.ROLE_QA;
const superAdminRole = AppConstants.ROLE_SUPER_ADMIN;
const affiliateManagerRole = AppConstants.ROLE_AFFILIATE_MANAGER;
const supportRole = AppConstants.ROLE_SUPPORT;
const financierRole = AppConstants.ROLE_FINANCIER;
const advertiserRole = AppConstants.ROLE_ADVERTISER;
let isImpersonating = '';
const getBrowserTimeZone = () => {
    try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone || null;
    } catch (e) {
        return null;
    }
};
const normalizeTimeZone = (timeZone) => {
    if (!timeZone || 'string' !== typeof timeZone) {
        return null;
    }

    try {
        return Intl.DateTimeFormat('en-US', { timeZone }).resolvedOptions().timeZone || timeZone;
    } catch (e) {
        return null;
    }
};

const UserStore = {
    getAccess() {
        const roles = store.getState().user?.roles || [];
        return roles.includes(publisherRole) || !roles.length;
    },

    getTimeZone() {
        return store.getState().user?.timezone;
    },

    getValidTimeZone(timeZone = null) {
        const targetTimeZone = timeZone === undefined || timeZone === null
            ? this.getTimeZone()
            : timeZone;

        return normalizeTimeZone(targetTimeZone)
            || normalizeTimeZone(this.getTimeZone())
            || normalizeTimeZone(getBrowserTimeZone())
            || 'UTC';
    },

    getLocale() {
        return store.getState().user?.locale || 'en';
    },

    getTranslation() {
        return translations[this.getLocale()];
    },

    getID() {
        return store.getState().user?.id || null;
    },

    getPublisherID() {
        return store.getState().user?.publisher?.id || null;
    },

    getImpersonating() {
        return isImpersonating;
    },

    setImpersonating(value) {
        isImpersonating = value;
    },

    isAdmin() {
        const roles = store.getState().user?.roles || [];

        return roles.includes(adminRole) ||
            roles.includes(qaRole) ||
            roles.includes(superAdminRole) ||
            roles.includes(affiliateManagerRole) ||
            roles.includes(supportRole) ||
            roles.includes(financierRole);
    },

    isQA() {
        const roles = store.getState().user?.roles || [];

        return roles.includes(qaRole);
    },

    isAdvertiser() {
        const roles = store.getState().user?.roles || [];

        return roles.includes(advertiserRole);
    },
};

export default UserStore;
